import { session } from './config.js';
import { hydrateIcons } from './icons.js';
import { OFFICIAL_ROUTES } from './auth.js';
import { viewDashboard } from './pages/dashboard.js';
import { viewUsers } from './pages/users.js';
import { viewAuto } from './pages/automatic.js';
import { viewManual } from './pages/manual.js';
import { viewPlant } from './pages/plant.js';

export const ROUTE_TITLE={dashboard:'Dashboard',users:'Users',auto:'Automatic Operations','manual-sha':'Manual Operations (Shamshabad)','manual-thu':'Manual Operations (Thumkunta)','sha-plant':'Shamshabad','thu-plant':'Thumkunta'};

export function toggleOps(){document.getElementById('opsGroup').classList.toggle('open')}

export function setActive(r){document.querySelectorAll('#nav a').forEach(a=>a.classList.toggle('active',a.dataset.route===r))}

export function go(route){
  if(session.role==='official'&&!OFFICIAL_ROUTES.includes(route))route='dashboard';
  setActive(route);document.getElementById('crumb').textContent=ROUTE_TITLE[route]||'';
  if(['auto','manual-sha','manual-thu'].includes(route))document.getElementById('opsGroup').classList.add('open');
  document.getElementById('sidebar').classList.remove('show');window.scrollTo({top:0});
  ({dashboard:viewDashboard,users:viewUsers,auto:viewAuto,'manual-sha':()=>viewManual('Shamshabad'),'manual-thu':()=>viewManual('Thumkunta'),'sha-plant':()=>viewPlant('Shamshabad'),'thu-plant':()=>viewPlant('Thumkunta')}[route])();
  hydrateIcons(document.getElementById('content'));
}
